export function isString(data) {
    return typeof data === 'string';
}
export function isNumber(data) {
    return typeof data === 'number' && !isNaN(data);
}
export function isDefined(data) {
    return typeof data !== 'undefined' && data !== null;
}
export function isBoolean(data) {
    return typeof data === 'boolean';
}
export function isPromise(data) {
    return data instanceof Promise;
}
export function isArray(data) {
    return Array.isArray(data);
}
export function isObject(data) {
    return !!data && !Array.isArray(data) && typeof data === 'object';
}
export function isFunction(data) {
    return typeof data === 'function';
}
export function isNil(data) {
    return data == null;
}
export function isError(data) {
    return data instanceof Error;
}
export function isDate(data) {
    return data instanceof Date;
}
export function isTruthy(data) {
    return !!data;
}
export function isNot(predicate) {
    return function (data) {
        return !predicate(data);
    };
}
